module.exports = __webpack_public_path__ + "static/media/thumbnail.8a69f52e.jpg";